module.exports = __webpack_public_path__ + "static/img/medal_other.9471ce46.png";